import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

const StyledTypography = styled(Typography)({
    fontWeight: "bold"
});

interface AddColumnButtonProps {
    addColumn: (fieldName: string) => void;
}

const AddColumnButton = ({ addColumn }: AddColumnButtonProps) => {
    const columnNameInput = useRef();

    useEffect(() => {
        const node = columnNameInput.current as any;
        if (node) node.focus();
    });

    const [anchorEl, setAnchorEl] = useState(null);

    const openPopover = (ev: any) => {
        setAnchorEl(ev.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onSubmit = (ev: any) => {
        ev.preventDefault();
        const node = columnNameInput.current as any;
        const fieldName = node.value.trim();
        if (!fieldName) return;
        addColumn(fieldName);
        handleClose();
    };

    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    return (
        <>
            <Button id="open-button" onClick={openPopover}>
                + Fact(Column)
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                <div className="small-popover">
                    <StyledTypography>
                        Fact Name:{" "}
                    </StyledTypography>

                    <form onSubmit={onSubmit}>
                        <div className="v-space-2">
                            <TextField
                                id="column-name"
                                variant="filled" 
                                inputRef={columnNameInput}
                                required
                            />
                        </div>
                        <div>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                className="popover-button"
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </div>
            </Popover>
        </>
    );
};

export default AddColumnButton;
